import React from 'react';

const UY = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_17"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_17)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3H21V5H10V3ZM10 7H21V9H10V7ZM0 11H21V13H0V11Z"
        fill="#005CB2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.88 6.88C6.65 8.125 6.12 9 5.5 9C4.88 9 4.35 8.126 4.12 6.88C2.875 6.65 2 6.12 2 5.5C2 4.88 2.874 4.35 4.12 4.12C4.35 2.875 4.88 2 5.5 2C6.12 2 6.65 2.874 6.88 4.12C8.125 4.35 9 4.88 9 5.5C9 6.12 8.126 6.65 6.88 6.88Z"
        fill="#FFEA7B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.187 6.187C6.123 7.79 5.84 9 5.5 9C5.16 9 4.877 7.79 4.813 6.187C3.21 6.123 2 5.84 2 5.5C2 5.16 3.21 4.877 4.813 4.813C4.877 3.21 5.16 2 5.5 2C5.84 2 6.123 3.21 6.187 4.813C7.79 4.877 9 5.16 9 5.5C9 5.84 7.79 6.123 6.187 6.187Z"
        fill="#FCD715"
      />
      <path
        d="M5.5 7C6.32843 7 7 6.32843 7 5.5C7 4.67157 6.32843 4 5.5 4C4.67157 4 4 4.67157 4 5.5C4 6.32843 4.67157 7 5.5 7Z"
        fill="#FCD715"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default UY;
